/* eslint-disable react/prop-types */
import { IoAlertCircle } from "react-icons/io5";
import "./styles.css";
import Swal from "sweetalert2";

function ManutencaoAlert({ title, message }) {
  const openMessage = () => {
    Swal.fire({
      title: title,
      text: message,
      icon: "warning",
    });
  };

  return (
    <div className="alertManutencao " onClick={openMessage}>
      <div className="textEllipsis">
        <IoAlertCircle color="white" size={30} />
        <b>{title}</b>
      </div>
    </div>
  );
}

export default ManutencaoAlert;
